// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__1cf2k","aside":"App_aside__u23HH","cover":"App_cover__zyN7l","main":"App_main__3xkkX"};